"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var styles_1 = require("@mui/material/styles");
var Lang_js_1 = require("../Lang.js");
function MinistrySidebar() {
    var _a = (0, react_1.useState)(0), value = _a[0], setValue = _a[1];
    var _b = (0, react_1.useState)(false), isDrawerOpen = _b[0], setIsDrawerOpen = _b[1];
    var theme = (0, styles_1.useTheme)();
    var isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down('sm'));
    var isSpanish = document.documentElement.lang === 'es' || document.documentElement.lang === 'pt';
    var paths = [
        '/app/ministry/recordings/',
        '/app/ministry/newsletter/',
        '/app/ministry/handbook/',
        '/app/ministry/meetings/',
        '/api/ministry/renewal/latest/',
        '/app/ministry/renewals/',
    ];
    if (isSpanish) {
        paths.push('/api/ministry/renewal/latest?lang=pt'); // Portuguese Renewal Form
        paths.push('/app/ministry/renewals/?lang=pt'); // Portuguese Past Renewals
    }
    (0, react_1.useEffect)(function () {
        var fullPath = window.location.pathname + window.location.search;
        var url = new URL(window.location.href);
        var isPT = url.searchParams.get('lang') === 'pt';
        var activeTab = paths.findIndex(function (path) {
            var _a = path.split('?'), basePath = _a[0], query = _a[1];
            // Match both Spanish and Portuguese edit pages
            if (basePath === '/api/ministry/renewal/latest/' &&
                fullPath.match(/^\/app\/ministry\/renewal\/edit\/\d+/)) {
                var pathIsPT = query === 'lang=pt';
                return isPT === pathIsPT;
            }
            return fullPath === path;
        });
        setValue(activeTab >= 0 ? activeTab : 0);
    }, []);
    var handleChange = function (_event, newValue) {
        var path = paths[newValue] || '/';
        var isPT = new URL(window.location.href).searchParams.get('lang') === 'pt';
        // If user is in PT and is navigating to any non-PT tab (index < 6)
        if (isPT && newValue < 6) {
            var redirectUrl = path + '?lang=es';
            window.location.href = redirectUrl;
        }
        else {
            window.location.href = path;
        }
        if (isMobile)
            setIsDrawerOpen(false);
    };
    var tabLabels = [
        (0, Lang_js_1.__)("Recordings"),
        (0, Lang_js_1.__)("Newsletter"),
        (0, Lang_js_1.__)("Key Info/Handbook"),
        (0, Lang_js_1.__)("Local Meetings"),
        (0, Lang_js_1.__)("Online Renewal Form"),
        (0, Lang_js_1.__)("Past Renewals"),
    ];
    if (isSpanish) {
        tabLabels.push((0, Lang_js_1.__)("Portuguese Renewal Form"));
        tabLabels.push((0, Lang_js_1.__)("Portuguese Past Renewals"));
    }
    return (react_1.default.createElement(material_1.Box, { className: "ministry-sidebar" },
        isMobile ? (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', padding: '2px' } },
            react_1.default.createElement(Typography_1.default, { sx: { marginRight: '1px', fontSize: '12px' } }, (0, Lang_js_1.__)("Menu")),
            react_1.default.createElement(material_1.IconButton, { color: "inherit", "aria-label": "open drawer", edge: "start", onClick: function () { return setIsDrawerOpen(true); }, size: "small" },
                react_1.default.createElement(Menu_1.default, null)),
            react_1.default.createElement(material_1.Drawer, { anchor: "left", open: isDrawerOpen, onClose: function () { return setIsDrawerOpen(false); } },
                react_1.default.createElement(material_1.Tabs, { orientation: "vertical", variant: "scrollable", value: value, onChange: handleChange, sx: { borderRight: 1, borderColor: 'divider' } }, tabLabels.map(function (label, i) { return (react_1.default.createElement(material_1.Tab, { key: i, label: label, className: isSpanish && i > 5 ? 'pt-tab' : '' })); }))))) : (react_1.default.createElement(material_1.Tabs, { orientation: "vertical", variant: "scrollable", value: value, onChange: handleChange, sx: { borderRight: 1, borderColor: 'divider' } }, tabLabels.map(function (label, i) { return (react_1.default.createElement(material_1.Tab, { key: i, label: label, className: isSpanish && i >= 6 ? 'pt-tab' : '' })); }))),
        react_1.default.createElement(material_1.Box, { className: "ministry-content" })));
}
exports.default = MinistrySidebar;
